import React, {useEffect, useState} from 'react';
import {VALIDATIONS, VALIDATIONS_TEXT} from "../../../../app-constants";
import {Button, Form} from "react-bootstrap";
import {useForm} from "react-hook-form";
import axios from "axios";
import { Container, Row, Col } from "react-bootstrap";
import TekLoader from "../../../images/Tek-Spinner.gif"

const FooterLanding = () => {

  const getBaseUrl = () => {
    if (
      typeof window !== "undefined" &&
      (window.location.href.includes(
        "https://staging-tekrevol.tekstagearea.com"
      ) ||
        window.location.href.includes("http://localhost:8000") ||
        window.location.href.includes("http://localhost:9000"))
    ) {
      return "https://tekrevol-form.tekstagearea.com/contact-form.php";
    } else {
      // return "https://tekrevol.tekstagearea.com/api/v1/contact-form";
      return "https://tekrevol-form.tekstagearea.com/contact-form.php";
    }
  };

  const {register, handleSubmit, watch, reset, formState: {errors}} = useForm({
    mode: "onChange"
});
const [Success, SetSuccess] = useState(false);
const [Loading, SetLoading] = useState(false);
const onSubmit = async (data) => {
    const url = window.location.href;
    data.form_path= url.split("?")[0];
    SetLoading(true);

    const baseUrl = getBaseUrl(); // Get the base URL
    const response = await axios.post(baseUrl, data);

    // const response = await axios.post(`https://tekrevol.tekstagearea.com/api/v1/contact-form`, data);
    
    SetSuccess(true);
    setTimeout(() => {
        SetSuccess(false)
    }, 2000)
    SetLoading(false);
    reset({
        name: '',
        email: '',
        phone: '',
        description: '',
    })
    ;
};
  return (
    <section className="footer_section p-100 hv-100" id="footercode">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="address_box">
              <div className="address_list">
                <h6>MIA</h6>
                <p>
                400 NW 26th St, Miami, FL 33127
                </p>
              </div>
              <div className="address_list">
                <h6>DC</h6>
                <p>740 15th St NW 8th Floor, Washington, DC 20005</p>
              </div>
              <div className="address_list">
                <h6>NYC</h6>
                <p>510 5th Ave 3rd Floor,New York, NY 10036</p>
              </div>
              <div className="address_list">
                <h6>HOU</h6>
                <p>4201 Main St Suite # 200-122, Houston, TX 77002</p>
              </div>
              <div className="address_list">
                <h6>SF</h6>
                <p>45 Tehama St, San Francisco, CA 94105</p>
              </div>
              <div className="address_list">
                <h6>CHI</h6>
                <p>222 W Merchandise Mart Plaza Floor 12, Suite 1212, Chicago, IL 60654</p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
          <div className="lp_form">
              <h5>
              Let's Start a Project Together
              </h5>
              <p>Let’s discuss your project and find out how we can help you scale!</p>
              <Form
                className="lp_form_inner"
                onSubmit={handleSubmit(onSubmit)}
                method="POST"
              >
                <Form.Group className="lp_from_item">
                  <Form.Control
                    type="text"
                    placeholder="Full Name"
                    name="name"
                    {...register("name", {
                      maxLength: {
                        value: VALIDATIONS.NAME,
                        message: VALIDATIONS_TEXT.NAME_MAX,
                      },
                      required: {
                        value: true,
                        message: VALIDATIONS_TEXT.NAME_REQUIRED,
                      },
                    })}
                  />
                  {errors.name && (
                    <span className="error_tek">{errors.name?.message}</span>
                  )}
                </Form.Group>
                <Form.Group className="lp_from_item">
                  <Form.Control
                    type="email"
                    placeholder="Email"
                    name="email"
                    {...register("email", {
                      maxLength: {
                        value: VALIDATIONS.EMAIL,
                        message: VALIDATIONS_TEXT.EMAIL_MAX,
                      },
                      required: {
                        value: true,
                        message: VALIDATIONS_TEXT.EMAIL_REQUIRED,
                      },
                      pattern: {
                        value: /\S+@\S+\.\S+/,
                        message: VALIDATIONS_TEXT.EMAIL_FORMAT,
                      },
                    })}
                  />
                  {errors.email && (
                    <span className="error_tek">{errors.email?.message}</span>
                  )}
                </Form.Group>
                <Form.Group className="lp_from_item">
                  <Form.Control
                    type="tel"
                    placeholder="Number"
                    name="phone"
                    {...register("phone", {
                      pattern: {
                         // value: /^\+?\d*$/,
                         value: /^\d+$/,
                         message: VALIDATIONS_TEXT.NUMBER_PHONE_FORMAT,
                       },
                       // minLength: {
                       //   value: VALIDATIONS.PHONE_MIN,
                       //   message: VALIDATIONS_TEXT.PHONE_MIN,
                       // },
                       // maxLength: {
                       //   value: VALIDATIONS.PHONE_MAX,
                       //   message: VALIDATIONS_TEXT.PHONE_MAX,
                       // },
                      required: {
                        value: true,
                        message: VALIDATIONS_TEXT.PHONE_REQUIRED,
                      },
                    })}
                  />
                  {errors.phone && (
                    <span className="error_tek">{errors.phone?.message}</span>
                  )}
                </Form.Group>
                <Form.Group className="lp_from_item">
                    <Form.Control as="textarea" rows={4} name="description"
                                  placeholder="Describe Your Project Need."
                                  {...register("description",
                                      {
                                          maxLength: {
                                              value: VALIDATIONS.DESCRIPTION_MAX,
                                              message: VALIDATIONS_TEXT.DESCRIPTION_MAX,
                                          },
                                          required: {
                                              value: true,
                                              message: VALIDATIONS_TEXT.DESCRIPTION_REQUIRED,
                                          },
                                      })
                                  }
                    />
                    {errors.description && <span className="error_tek">{errors.description?.message}</span>}
                </Form.Group>
    
                {!Loading ? (
                  <Button
                    variant="primary"
                    className="btn_submit"
                    type="submit"
                  >
                  Submit
                  </Button>
                ) : (
                  <img
                  src={TekLoader}
                    alt="img_looder"
                    className="img-fluid looder_img"
                  />
                )}
              </Form>
              {Success ? (
                <div className="alert-success">
                  Thank you for your message. It has been sent.
                </div>
              ) : (
                ""
              )}
            </div>
          </Col>
        </Row>
      </Container>
      <section class="copright_lp copyright_web_lp">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={10} xl={10} xxl={10} className="text-center m-auto">
                        <p>COPYRIGHT 2024 TEKREVOL ALL RIGHTS RESERVED.</p>
                    </Col>
                </Row>
            </Container>
        </section>
    </section>
  );
};

export default FooterLanding;
